var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDuplicateBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.733,
    height: 22.733,
    viewBox: "0 0 22.733 22.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy-solid",
    d: "M9.946,0A2.844,2.844,0,0,0,7.1,2.842v9.946a2.844,2.844,0,0,0,2.842,2.842h9.946a2.844,2.844,0,0,0,2.842-2.842V2.842A2.844,2.844,0,0,0,19.892,0Zm-7.1,7.1A2.844,2.844,0,0,0,0,9.946v9.946a2.844,2.844,0,0,0,2.842,2.842h9.946a2.844,2.844,0,0,0,2.842-2.842V17.05H12.788v2.842H2.842V9.946H5.683V7.1Z",
    fill: "#022767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuplicateBlue);
export default __webpack_public_path__ + "static/media/icon-duplicate-blue.4868050ece3ff0fad6f750c103ddd649.svg";
export { ForwardRef as ReactComponent };